export function eventsEmit(eventName, eventValue) {
  // イベント名の設定 see: https://github.com/krayinc/tx-frontend/issues/97#issuecomment-2994663797
  if (Object.keys(eventValue).length !== 0 ) {
    const value = Object.entries(eventValue).map(([key, value]) => `${key}.${value}`).join('.');
    eventName += `.${value}`;
  }

  console.log('start appbox.events.emit');
  console.log('eventName:', eventName);
  console.log(appbox.events.emit);
  appbox.events.emit(eventName);
}

export function lineNameAbbr(lineName) {
   switch (lineName) {
    case '山手線':
    case 'JR山手線':
      return 'JY';

    case '中央・総武線各駅停車':
    case 'JR中央・総武線各駅停車':
      return 'JB';

    case '京浜東北線':
    case 'JR京浜東北線':
      return 'JK';

    case '日比谷線':
    case '東京メトロ日比谷線':
      return 'H';

    case '都営新宿線(岩本町駅)':
      return 'S';

    case '大江戸線':
    case '都営大江戸線':
      return 'E';

    case '常磐線快速電車/常磐線':
    case 'JR常磐線快速電車/常磐線':
      return 'JL';

    case 'スカイツリーライン':
    case '東武スカイツリーライン':
      return 'TS';

    case '千代田線':
    case '東京メトロ千代田線':
      return 'C';

    case '武蔵野線（東京～府中本町）':
    case 'JR武蔵野線（東京～府中本町）':
      return 'JM1';

    case '武蔵野線（海浜幕張～府中本町）':
    case 'JR武蔵野線（海浜幕張～府中本町）':
      return 'JM2';

    case 'アーバンパークライン':
    case '東武アーバンパークライン':
      return 'TD';

    default:
      console.log(`lineNameAbbr エラー: ${lineName}`);

      return lineName;
  }
}
